import Content from '@/layout/content';
import Layout from '@/layout';

export default {
  path: '/task',
  component: window.name ? Content : Layout,
  redirect: '/task/monitor',
  meta: {
    title: '任务监控',
    icon: 'iconfont icon-job',
    code: '010208'
  },
  children: [
    {
      path: 'monitor',
      name: 'taskMonitor',
      component: () => import('@/views/task'),
      meta: {
        activeMenu: '/task'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
